"use client"

import React from "react"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
  Divider,
} from "@mui/material"
import { FilterList as FilterListIcon, Clear as ClearIcon } from "@mui/icons-material"
import { motion } from "framer-motion"

const FilterDialog = ({
  open,
  onClose,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  sortOrder,
  setSortOrder,
  departmentName,
  setDepartmentName,
  email,
  setEmail,
  applyFilters,
  onClear,
}) => {
  const handleApply = () => {
    applyFilters()
    onClose()
  }

  const handleClear = () => {
    onClear()
    onClose()
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
        },
      }}
    >
      <DialogTitle>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <motion.div
            animate={{ rotate: [0, 10, -10, 0] }}
            transition={{ duration: 2, repeat: Infinity }}
          >
            <FilterListIcon sx={{ color: "primary.main" }} />
          </motion.div>
          <Typography variant="h6" fontWeight={600}>
            Filter Requests
          </Typography>
        </Box>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ py: 3 }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          {/* Date Range */}
          <Box>
            <Typography variant="subtitle2" fontWeight={600} gutterBottom color="primary">
              Date Range
            </Typography>
            <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
              <TextField
                label="Start Date"
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
              <TextField
                label="End Date"
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            </Box>
          </Box>

          {/* Sort Order */}
          <Box>
            <Typography variant="subtitle2" fontWeight={600} gutterBottom color="primary">
              Sort Order
            </Typography>
            <FormControl fullWidth>
              <InputLabel>Sort by Date</InputLabel>
              <Select value={sortOrder} onChange={(e) => setSortOrder(e.target.value)} label="Sort by Date">
                <MenuItem value="asc">Oldest First</MenuItem>
                <MenuItem value="desc">Newest First</MenuItem>
              </Select>
            </FormControl>
          </Box>
{/* 
          <Box>
            <Typography variant="subtitle2" fontWeight={600} gutterBottom color="primary">
              Department
            </Typography>
            <TextField
              label="Department Name"
              value={departmentName}
              onChange={(e) => setDepartmentName(e.target.value)}
              fullWidth
            />
          </Box> */}
{/* 
          <Box>
            <Typography variant="subtitle2" fontWeight={600} gutterBottom color="primary">
              Email
            </Typography>
            <TextField
              label="User Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
            />
          </Box> */}
        </Box>
      </DialogContent>

      <Divider />

      <DialogActions sx={{ p: 3, gap: 2 }}>
        <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
          <Button
            onClick={handleClear}
            startIcon={<ClearIcon />}
            sx={{
              borderRadius: 2,
              fontWeight: 600,
              color: "text.secondary",
            }}
          >
            Clear All
          </Button>
        </motion.div>

        <Box sx={{ display: "flex", gap: 1 }}>
          <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
            <Button onClick={onClose} sx={{ borderRadius: 2, fontWeight: 600 }}>
              Cancel
            </Button>
          </motion.div>

          <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
            <Button
              onClick={handleApply}
              variant="contained"
              startIcon={<FilterListIcon />}
              sx={{
                borderRadius: 2,
                fontWeight: 600,
                background: "linear-gradient(135deg, #FF8000 0%, #FFB366 100%)",
              }}
            >
              Apply Filters
            </Button>
          </motion.div>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

export default FilterDialog
